/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_Li5_LabelInputs */

const tr_onbilgi_s10_li5_label = /** @type {(inputs: Onbilgi_S10_Li5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yedekleme:`)
};

const en_onbilgi_s10_li5_label = /** @type {(inputs: Onbilgi_S10_Li5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup:`)
};

const de_onbilgi_s10_li5_label = /** @type {(inputs: Onbilgi_S10_Li5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherung:`)
};

const ru_onbilgi_s10_li5_label = /** @type {(inputs: Onbilgi_S10_Li5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Резервное копирование:`)
};

/**
* | output |
* | --- |
* | "Backup:" |
*
* @param {Onbilgi_S10_Li5_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_li5_label = /** @type {((inputs?: Onbilgi_S10_Li5_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_Li5_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_li5_label(inputs)
	if (locale === "de") return de_onbilgi_s10_li5_label(inputs)
	if (locale === "ru") return ru_onbilgi_s10_li5_label(inputs)
	return tr_onbilgi_s10_li5_label(inputs)
});